import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f2cef3b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2f2cef3b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2cef3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2cef3b')) {
      api.createRecord('2f2cef3b', component.options)
    } else {
      api.reload('2f2cef3b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f2cef3b&scoped=true", function () {
      api.rerender('2f2cef3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/index.vue"
export default component.exports